module.exports = __webpack_public_path__ + "img/zy1.48d63cb4.png";